import Config from './Config';

const expiryHours = 3; // データの有効期限を３時間にする

const keys = Config.keys;

const get = ( key: string ) => {
    if ( !Config.defaultValues.hasOwnProperty(key) ) return false;
    const rowDescriptor = Object.getOwnPropertyDescriptor(Config.defaultValues, key);
    const defaultValue = rowDescriptor ? rowDescriptor.value : null;
    const data: any = localStorage.getItem(key);
    if (!data) {
        return defaultValue;
    }
    const rowData = JSON.parse(data);
    if (!checkExpired(rowData.expired)) {
        return defaultValue;
    }
    set(key, rowData.value); // 有効期限延長
    return rowData.value;
};

const set = ( key: string, value: any ) => {
    if (!Config.defaultValues.hasOwnProperty(key)) return false;
    localStorage.setItem(key, JSON.stringify({
        value: value,
        expired: getExpired()
    }));
    return true;
};

const getExpired = () => {
    const date = new Date();
    date.setHours(date.getHours() + expiryHours);
    return date.getTime();
};

const checkExpired = ( targetTime: number ) => {
    const date = new Date();
    return (date.getTime() < targetTime);
};

const Storage = {
    get,
    set,
    keys
};

export default Storage;